export default "__VITE_ASSET__CCUmI_bU__"